import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-content" }
const _hoisted_2 = { class: "modal-body p-4" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = { class: "mt-2" }
const _hoisted_5 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalConsulte = _resolveComponent("ModalConsulte")!

  return (_openBlock(), _createBlock(_component_ModalConsulte, {
    ref: "modalRef",
    "hide-footer": true,
    "hide-header": true,
    modalWidth: "300px !important"
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[1] || (_cache[1] = _createElementVNode("i", {
              class: "ri-alert-line h1 text-warning",
              "aria-hidden": "true"
            }, null, -1)),
            _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.titulo), 1),
            _createElementVNode("p", {
              class: "mt-3",
              innerHTML: _ctx.mensagem
            }, null, 8, _hoisted_5),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-warning my-2 mx-2",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onSim && _ctx.onSim(...args)))
            }, "OK")
          ])
        ])
      ])
    ]),
    _: 1
  }, 512))
}